<template>
  <span class="child-list-select" style="padding-bottom: 20px">
    <select v-if="children" v-model="selectedChild2" class="form-control">
        <option
            v-bind:key="child.id"
            v-for="child in children"
            :value="child"
            :selected="isSelected(child)"
        >
            {{ child.full_name }}
          </option>
    </select>
  </span>
</template>

<script>
export default {
  name: 'child-list',
  props: ['type', 'filteredChildren', 'route'],
  computed: {
    children () {
      if (this.filteredChildren) {
        return this.getPartialChildren(this.filteredChildren)
      }
      return this.getChildren()
    }
  },
  watch: {
    selectedChild2 (newVal) {
      this.$store.commit('SET_SELECTED_CHILD', newVal)
    }
  },
  data () {
    return {
      selectedChild2: null
    }
  },
  created () {
    if (this.selectedChild) {
      this.selectedChild2 = this.selectedChild
    }
  },
  methods: {
    sort (children, by) {
      by = by || this.getApplicationSetting('ipad_sort_children_by')
      if (by === false) {
        by = 'first_name'
      }
      return this.$lodash().sortBy(children, [child => child[by].toLowerCase()], 'asc')
    },
    isSelected (child) {
      if (this.selectedChild && child.id !== undefined && parseInt(child.id) === parseInt(this.selectedChild.id)) {
        return true
      } else if (this.selectedChild && child.id_child !== undefined && parseInt(child.id_child) === parseInt(this.selectedChild.id)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
</style>
